import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Calculator from "@/pages/Calculator";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminQuotes from "@/pages/admin/AdminQuotes";
import AdminQuoteDetail from "@/pages/admin/AdminQuoteDetail";
import AdminServices from "@/pages/admin/AdminServices";
import AdminPricing from "@/pages/admin/AdminPricing";
import AdminTravelFees from "@/pages/admin/AdminTravelFees";
import AdminPromoCodes from "@/pages/admin/AdminPromoCodes";
import AdminAccount from "@/pages/admin/AdminAccount";
import AdminNotifications from "@/pages/admin/AdminNotifications";
import AdminGallery from "@/pages/admin/AdminGallery";
import AdminTestimonials from "@/pages/admin/AdminTestimonials";
import "@/App.css";

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Toaster position="top-right" richColors closeButton />
                <div className="App">
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/orcamento" element={<Calculator />} />
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route
                            path="/admin"
                            element={
                                <ProtectedRoute>
                                    <AdminLayout />
                                </ProtectedRoute>
                            }
                        >
                            <Route index element={<AdminOverview />} />
                            <Route path="pedidos" element={<AdminQuotes />} />
                            <Route path="pedidos/:id" element={<AdminQuoteDetail />} />
                            <Route path="servicos" element={<AdminServices />} />
                            <Route path="precos" element={<AdminPricing />} />
                            <Route path="deslocacao" element={<AdminTravelFees />} />
                            <Route path="promocoes" element={<AdminPromoCodes />} />
                            <Route path="galeria" element={<AdminGallery />} />
                            <Route path="testemunhos" element={<AdminTestimonials />} />
                            <Route path="notificacoes" element={<AdminNotifications />} />
                            <Route path="conta" element={<AdminAccount />} />
                        </Route>
                    </Routes>
                </div>
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
